module.exports = __webpack_public_path__ + "img/geyw-table@2x.3c36ae40.png";